"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var url_utils_1 = require("@zapier/url-utils");
var cookies_1 = require("@zapier/cookies");
var constants_1 = __importStar(require("./constants"));
var utils_1 = require("./utils");
var TrackingCookies = {
    /* Returns the cookie name based on the ID, e.g. __fbclid */
    getClickIdCookieName: function (id) {
        return "__" + id;
    },
    /* Retrieves a cookie for a single click ID query parameter, e.g. fbclid, gclid, msclkid */
    retrieveClickId: function (id) {
        var cookie = cookies_1.readCookie(this.getClickIdCookieName(id));
        if (cookie) {
            try {
                return atob(cookie);
            }
            catch (e) {
                console.error("Error retrieving " + id + ": " + e);
            }
        }
        return null;
    },
    /* Stores a cookie for a single click ID query parameter, e.g. fbclid, gclid, msclkid */
    storeClickId: function (id, href) {
        if (href === void 0) { href = window.location.href; }
        if (utils_1.isBrowser()) {
            var params = url_utils_1.extractParams(href);
            var param = params[id];
            if (param) {
                cookies_1.writeCookie(this.getClickIdCookieName(id), btoa(param), {
                    category: 'marketing',
                    maxAge: constants_1.default.CLICK_ID_COOKIE_EXPIRATION,
                });
            }
        }
    },
    /* Iterates through all ClickIds values and fetches cookies for each, e.g. fbclid, gclid, msclkid */
    retrieveAllClickIds: function () {
        var _this = this;
        Object.values(constants_1.ClickIds).forEach(function (id) {
            _this.retrieveClickId(id);
        });
    },
    /* Iterates through all ClickIds values and stores cookies for each, e.g. fbclid, gclid, msclkid */
    storeAllClickIds: function () {
        var _this = this;
        Object.values(constants_1.ClickIds).forEach(function (id) {
            _this.storeClickId(id);
        });
    },
    retrieveUtms: function () {
        if (utils_1.isBrowser()) {
            var utmCookie = cookies_1.readCookie(constants_1.default.UTM_COOKIE_NAME);
            if (utmCookie) {
                try {
                    return JSON.parse(utmCookie);
                }
                catch (e) {
                    // If we fail to parse the cookie, then we will resolve everything
                    // as `undefined`.
                }
            }
        }
        return {
            utm_campaign: undefined,
            utm_source: undefined,
            utm_content: undefined,
            utm_medium: undefined,
            utm_term: undefined,
        };
    },
    storeUtms: function (url) {
        if (utils_1.isBrowser()) {
            try {
                var href = url || window.location.href;
                var params = url_utils_1.extractParams(href);
                var utmParams = lodash_1.pick(params, constants_1.default.UTM_PARAM_NAMES);
                if (lodash_1.keys(utmParams).length > 0) {
                    cookies_1.writeCookie(constants_1.default.UTM_COOKIE_NAME, JSON.stringify(utmParams), {
                        category: 'marketing',
                        maxAge: constants_1.default.UTM_COOKIE_EXPIRATION,
                    });
                }
                return undefined;
            }
            catch (e) {
                // If we fail to set the cookie, then we will resolve `undefined`.
            }
        }
        return undefined;
    },
};
exports.default = TrackingCookies;
